import { RichText as RichTextData } from '@silvertours/common-landingpages-view';
import { Ui } from '@silvertours/front-shared';

import { HasTextStyleRules } from './rule';
import { LinkButton } from './LinkButton';
import { HasColumns } from '../rule';

import { RichTextWrapper } from './RichText.styles';

export type RichTextRules = HasColumns &
  HasTextStyleRules & {
    disableSnippetStyles?: boolean;
  };

export type RichTextProps = {
  content: RichTextData;
  rules?: RichTextRules;
};

// Same button as the standard-content module button (StandardContentRowBlock),
// so an embedded ctaLink looks, works and is tracked the same.
const renderCtaLink: Ui.RenderCtaLink = link => (
  <LinkButton content={link} rules={{ variant: 'secondary', size: 'small' }} />
);

export const RichText = (props: RichTextProps) => {
  const { content, rules = {} } = props;
  const { textStyle, columns, disableSnippetStyles } = rules;
  const isMultiColumn = columns && columns.length > 1;

  return (
    <RichTextWrapper rules={rules}>
      <Ui.RichText
        content={content}
        rules={{ textStyle, isMultiColumn, disableSnippetStyles }}
        renderCtaLink={renderCtaLink}
      />
    </RichTextWrapper>
  );
};
